export default {
  wrapper: {
    display: 'flex',
    padding: 10,
    backgroundColor: 'white',
    borderRadius: 4,
    width: '100%',
    borderBottom: '1px solid #E2E2FC',
    justifyContent: 'space-between',
    position: 'relative',
    '& + *': {
      marginTop: 12,
    },
  },
  questionCheckBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    border: 0,
  },
  columnsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    width: '75%',
  },
  titleWrapper: {
    width: 'calc(100% - 110px)',
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '70px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginLeft: 20,
    '& > * + *': {
      marginLeft: 12,
    },
  },

  input: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'white',
    width: '100%',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '500',
    color: '#011533',
  },
  inputWithUnderline: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'white',
    width: '100%',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '500',
    color: '#011533',
    borderBottom: '1px solid #E2E2FC',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  button: {
    minWidth: 23,
    minHeight: 23,
    borderRadius: 4,
    marginLeft: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    '&:active': {
      opacity: 0.5,
    },
  },
  buttonAdd: {
    backgroundColor: '#004360',
    width: 25,
    height: 25,
    marginTop: 12,
    marginLeft: 22,
  },
  buttonDelete: {
    marginLeft: 20,
  },
  typeIcon: {
    '& + *': {
      marginLeft: 12,
    },
  },
  typeIconCircle: {
    width: 16,
    height: 16,
    borderRadius: '50%',
    border: '1px solid #C4C4C4',
  },
  disabledBlock: {
    pointerEvents: 'none',
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  hint: {
    position: 'absolute',
    fontSize: 12,
    opacity: 0.7,
    color: 'red',
  },
  checkbox: { width: 'auto', '& + *': { marginLeft: '16px !important' } },
  transpatentButton: {
    backgroundColor: 'transparent',
  },
  typeItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
  },
  typeItemText: {
    marginLeft: 14,
    marginBottom: 4,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '500',
    color: '#011533',
    fontSize: 16,
    pointerEvents: 'none',
  },
  checkBoxContainer: {
    height: 25,
    cursor: 'pointer',
  },
}
